import { restClient } from 'config/store/configureStore';

import { FLEETBACK_PACKS_URL, ODITOO_PACKS_URL } from 'constants/ApiConstants';

export default {
  getFleetbackPacks: params => restClient.get(FLEETBACK_PACKS_URL, { params }),
  getOditooPacks: params => restClient.get(ODITOO_PACKS_URL, { params }),
};
